import { type TextareaHTMLAttributes, forwardRef } from 'react';

import { cn } from '@/lib/utils';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-[100px] w-full rounded-md border border-ugin-border bg-ugin-surface-elevated px-3 py-2 text-sm text-ugin-text',
        'placeholder:text-ugin-text-faint',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ugin-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ugin-bg',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'font-mono leading-relaxed',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
